module.exports = __webpack_public_path__ + "static/lifetime-warranty-ca1f143670510c2a2758012fefe6b9a3.png";